// Theme JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Add any interactive functionality here
  
  // Example: Quick view modal (placeholder)
  const quickViewButtons = document.querySelectorAll('.product-card__quick-view');
  quickViewButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.dataset.productId;
      // Implement quick view logic
      console.log('Quick view for product:', productId);
    });
  });
  
  // Smooth scrolling for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});